import Vue from 'vue'
import Element from 'element-ui'
import App from '@/App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import '@/icons'
import '@/element-ui/theme/index.css'
import '@/assets/scss/aui.scss'
import http from '@/utils/request'
import {hasPermission} from '@/utils'
import {openLoading} from '@/utils/index'
import cloneDeep from 'lodash/cloneDeep'
import Cookies from 'js-cookie'
import echarts from 'echarts'
import '../node_modules/echarts/map/js/china.js'

Vue.config.productionTip = false

Vue.use(Element, {
    size: 'default',
    i18n: (key, value) => i18n.t(key, value)
})
Vue.prototype.openLoading = openLoading
// 挂载全局
Vue.prototype.$http = http
Vue.prototype.$hasPermission = hasPermission
Vue.prototype.cookie = Cookies
Vue.prototype.$echarts = echarts
// 保存整站vuex本地储存初始状态
window.SITE_CONFIG['storeState'] = cloneDeep(store.state)

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
